export const VERIFICATION_TYPE_PHONE_NUMBER_SMS: string = 'phone-number-sms';
export const VERIFICATION_TYPE_AUTHENTICATOR_APP_OTP: string = 'authenticator-app-otp';
